import compose from 'utils/composeEnhancer'
import handleMenu from 'hooks/handleMenu'
import toggleSidebarStore from 'hooks/toggleSidebarStore'

export default compose(
  handleMenu,
  toggleSidebarStore
)
